import { render, staticRenderFns } from "./FaceDirectionResultEffectFaceUp3.vue?vue&type=template&id=4a7ff4b0&"
import script from "./FaceDirectionResultEffectFaceUp3.vue?vue&type=script&lang=ts&"
export * from "./FaceDirectionResultEffectFaceUp3.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports